import React, { useEffect, useRef, useState } from 'react';

export const InputTextArea = props => {
  const {
    initValue,
    resetValue,
    onBlur,
    onChange,
    placeholder,
    className,
    rows = 3,
    maxRows = 8,
    autoResize = true,
  } = props;

  const [value, setValue] = useState(initValue ?? '');
  const ref = useRef(null);

  useEffect(() => {
    setValue(initValue ?? '');
  }, [initValue]);

  useEffect(() => {
    if (resetValue !== undefined && resetValue !== value) {
      setValue(resetValue ?? '');
    }
  }, [resetValue, value]);

  useEffect(() => {
    if (!autoResize) {
      return;
    }
    if (ref?.current) {
      ref.current.style.height = 'auto';
      const nextHeight = Math.min(
        ref.current.scrollHeight,
        maxRows * 24 + 16
      );
      ref.current.style.height = nextHeight + 'px';
    }
  }, [value, maxRows, autoResize]);

  const handleChange = e => {
    setValue(e.target.value);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <textarea
      ref={ref}
      className={`rounded bg-main bg-opacity-50 text-contrast text-opacity-80 flex-1 m-1 px-1 py-05 resize-none ${className}`}
      placeholder={placeholder}
      value={value}
      rows={rows}
      onMouseDownCapture={event => {
        event.stopPropagation();
      }}
      onPointerDownCapture={event => {
        event.stopPropagation();
      }}
      onTouchStartCapture={event => {
        event.stopPropagation();
      }}
      onChange={handleChange}
      onBlur={() => onBlur && onBlur(value)}
    ></textarea>
  );
};
